module.exports = __webpack_public_path__ + "img/Training_Support.411099d4.jpg";